// extracted by mini-css-extract-plugin
module.exports = {"hidden":"review_hidden__hxWrA","textEmphasis":"review_textEmphasis__j2Ffl","banner":"review_banner__iHrfe","divider":"review_divider__25QSO","label":"review_label__4QRKK"};